<template>
  <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
    <v-layout wrap>
      <v-flex xs12 pa-0 text-right class="buttonBar">
        <slot/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ButtonBar'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ButtonBar.vue